import { ProductListToolTip } from 'autogen/translation-keys/trans-website-brandclub';
import format from 'helpers/translations';
import React from 'react';
import FollowButton, { type FollowButtonProps } from './FollowButton';
import { useTranslation } from 'react-i18next';
import PlainTooltipPopup from 'components/shared/TooltipNotification/PlainTooltipPopup';

export default function FollowButtonWithTooltip(props: FollowButtonProps) {
    const { t } = useTranslation();

    return (
        <PlainTooltipPopup
            name="followButtonTooltip"
            description={format(t(ProductListToolTip), props.brandClubName)}
            screenTimeLimitSeconds={10}
            maxWidth={175}
        >
            <FollowButton {...props} />
        </PlainTooltipPopup>
    );
}
